// import React from "react";
// import { Row , Col } from 'react-bootstrap';
// import Box from '@mui/material/Box';
// import Container from '@mui/material/Container';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemAvatar from '@mui/material/ListItemAvatar';
// import DialogTitle from '@mui/material/DialogTitle';
// import Dialog from '@mui/material/Dialog';
// import CouponCard from "./CouponCard";
// import {loader} from '../../utils/image';
// import './index.css';
// import { Style } from "@mui/icons-material";

// const coupons = [
//     {
//         title:'Percentage discount',
//         path:'M52.7975 36.5225C52.6803 36.281 52.6194 36.016 52.6194 35.7475C52.6194 35.479 52.6803 35.214 52.7975 34.9725L54.1225 31.9725C54.3948 31.3761 54.5357 30.7282 54.5357 30.0726C54.5357 29.417 54.3948 28.769 54.1225 28.1726C53.8647 27.5908 53.4896 27.0685 53.0207 26.6383C52.5519 26.2081 51.9993 25.8794 51.3975 25.6726L48.3225 24.5225C48.0742 24.4232 47.8487 24.2744 47.6596 24.0854C47.4706 23.8963 47.3218 23.6708 47.2225 23.4225L46.0475 20.3225C45.8151 19.7176 45.4621 19.1662 45.0098 18.7021C44.5575 18.2379 44.0155 17.8707 43.4167 17.6228C42.818 17.3749 42.175 17.2514 41.527 17.2599C40.879 17.2685 40.2395 17.4089 39.6475 17.6725L36.6475 19.0475C36.1503 19.2477 35.5948 19.2477 35.0975 19.0475L32.0975 17.6725C31.5042 17.4049 30.8625 17.2613 30.2117 17.2506C29.5609 17.24 28.9147 17.3626 28.313 17.6107C27.7113 17.8589 27.1667 18.2275 26.7126 18.6938C26.2585 19.1601 25.9046 19.7144 25.6725 20.3225L24.5225 23.4225C24.4232 23.6708 24.2744 23.8963 24.0854 24.0854C23.8963 24.2744 23.6708 24.4232 23.4225 24.5225L20.3225 25.6726C19.7144 25.9046 19.1601 26.2585 18.6938 26.7126C18.2275 27.1667 17.8589 27.7114 17.6107 28.3131C17.3626 28.9148 17.24 29.5608 17.2506 30.2116C17.2613 30.8624 17.4049 31.5043 17.6725 32.0976L19.0475 35.0975C19.2477 35.5947 19.2477 36.1502 19.0475 36.6475L17.6725 39.6475C17.4071 40.2413 17.2699 40.8845 17.2699 41.535C17.2699 42.1855 17.4071 42.8287 17.6725 43.4225C17.9224 44.0051 18.2918 44.5287 18.7569 44.9594C19.222 45.39 19.7725 45.7182 20.3725 45.9225L23.4725 47.0976C23.7208 47.1969 23.9463 47.3455 24.1354 47.5346C24.3245 47.7237 24.4732 47.9493 24.5725 48.1976L25.7225 51.2725C26.0653 52.1777 26.6736 52.9579 27.4678 53.5112C28.2619 54.0644 29.2047 54.3647 30.1725 54.3725C30.8539 54.3757 31.5277 54.2307 32.1475 53.9476L35.1475 52.5726C35.3911 52.4617 35.6549 52.4021 35.9225 52.3976C36.1927 52.4044 36.4578 52.4727 36.6975 52.5975L39.6975 53.9225C40.2897 54.1943 40.9335 54.335 41.585 54.335C42.2366 54.335 42.8803 54.1943 43.4725 53.9225C44.0774 53.6791 44.624 53.3103 45.0764 52.8407C45.5288 52.3711 45.8768 51.8111 46.0975 51.1975L47.2725 48.1225C47.3719 47.8743 47.5205 47.6488 47.7096 47.4597C47.8987 47.2706 48.1243 47.1219 48.3725 47.0225L51.4475 45.8476C52.0492 45.6408 52.6018 45.3119 53.0707 44.8817C53.5396 44.4515 53.9147 43.9293 54.1725 43.3476C54.4442 42.7555 54.585 42.1116 54.585 41.4601C54.585 40.8086 54.4442 40.1647 54.1725 39.5726L52.7975 36.5225ZM28.5225 31.0475C28.5225 30.3181 28.8122 29.6188 29.328 29.1031C29.8437 28.5873 30.5432 28.2975 31.2725 28.2975C32.0019 28.2975 32.7013 28.5873 33.2171 29.1031C33.7328 29.6188 34.0225 30.3181 34.0225 31.0475C34.0225 31.7768 33.7328 32.4763 33.2171 32.9921C32.7013 33.5078 32.0019 33.7976 31.2725 33.7976C30.5432 33.7976 29.8437 33.5078 29.328 32.9921C28.8122 32.4763 28.5225 31.7768 28.5225 31.0475ZM32.4225 42.8476C32.2922 43.0299 32.1193 43.1775 31.9188 43.2777C31.7184 43.3779 31.4966 43.4276 31.2725 43.4225C30.9679 43.4193 30.6713 43.3234 30.4225 43.1475C30.2709 43.0363 30.1429 42.8962 30.0457 42.7353C29.9485 42.5743 29.8841 42.3958 29.8562 42.2099C29.8283 42.024 29.8375 41.8345 29.8832 41.6522C29.9289 41.4698 30.0102 41.2984 30.1225 41.1476L39.4975 28.6476C39.7333 28.3508 40.0727 28.1542 40.4475 28.0975H40.6725C40.9818 28.0972 41.2819 28.2031 41.5225 28.3975C41.6749 28.5084 41.8035 28.6489 41.9003 28.8107C41.9971 28.9725 42.0602 29.1522 42.0859 29.339C42.1116 29.5257 42.0993 29.7158 42.0498 29.8977C42.0002 30.0796 41.9144 30.2495 41.7975 30.3975L32.4225 42.8476ZM40.6475 43.1726C40.1036 43.1726 39.5719 43.0112 39.1197 42.709C38.6674 42.4068 38.315 41.9774 38.1069 41.4749C37.8987 40.9724 37.8442 40.4194 37.9503 39.886C38.0564 39.3525 38.3184 38.8626 38.703 38.4781C39.0876 38.0935 39.5776 37.8314 40.111 37.7253C40.6445 37.6192 41.1974 37.6738 41.6999 37.8819C42.2024 38.09 42.6319 38.4425 42.9341 38.8948C43.2363 39.347 43.3975 39.8786 43.3975 40.4225C43.3844 41.1431 43.0889 41.8299 42.5746 42.3349C42.0603 42.8398 41.3683 43.1226 40.6475 43.1225V43.1726Z',
//          subTitle:'Offer a percentage discount to your customers.',
//         color:'#89c74a'
//     },
//     {
//         title:'Flat discount',
//         path:'M52.9082 37.0358C52.7931 36.7972 52.7333 36.5355 52.7333 36.2703C52.7333 36.0051 52.7931 35.7434 52.9082 35.5048L54.2095 32.5417C54.4769 31.9526 54.6153 31.3127 54.6153 30.6651C54.6153 30.0175 54.4769 29.3775 54.2095 28.7884C53.9563 28.2138 53.588 27.6979 53.1275 27.273C52.667 26.8481 52.1243 26.5234 51.5333 26.3191L48.5133 25.1832C48.2695 25.0851 48.048 24.9382 47.8624 24.7514C47.6767 24.5646 47.5306 24.3419 47.433 24.0967L46.279 21.0348C46.0508 20.4373 45.7041 19.8927 45.2599 19.4342C44.8158 18.9758 44.2834 18.6131 43.6954 18.3682C43.1073 18.1233 42.4759 18.0014 41.8395 18.0098C41.2031 18.0183 40.575 18.157 39.9936 18.4174L37.0474 19.7754C36.559 19.9732 36.0135 19.9732 35.5251 19.7754L32.5788 18.4174C31.9961 18.1529 31.3659 18.0111 30.7267 18.0006C30.0876 17.9901 29.453 18.1112 28.8621 18.3563C28.2711 18.6014 27.7362 18.9655 27.2903 19.4261C26.8443 19.8867 26.4967 20.4342 26.2688 21.0348L25.1394 24.0967C25.0418 24.3419 24.8958 24.5646 24.7101 24.7514C24.5244 24.9382 24.3029 25.0851 24.0591 25.1832L21.0146 26.3191C20.4174 26.5484 19.873 26.8979 19.415 27.3464C18.957 27.7949 18.5951 28.3329 18.3514 28.9272C18.1076 29.5216 17.9873 30.1596 17.9977 30.8024C18.0081 31.4452 18.1491 32.0792 18.412 32.6652L19.7624 35.6283C19.959 36.1194 19.959 36.6681 19.7624 37.1592L18.412 40.1224C18.1513 40.709 18.0166 41.3443 18.0166 41.9867C18.0166 42.6292 18.1513 43.2645 18.412 43.8511C18.6574 44.4265 19.0202 44.9437 19.477 45.3691C19.9338 45.7945 20.4744 46.1185 21.0637 46.3204L24.1082 47.481C24.352 47.5791 24.5735 47.7259 24.7592 47.9127C24.9449 48.0994 25.0909 48.3223 25.1885 48.5675L26.3179 51.6047C26.6546 52.4987 27.252 53.2694 28.0319 53.8158C28.8119 54.3623 29.7378 54.6589 30.6883 54.6666C31.3574 54.6697 32.0192 54.5266 32.6279 54.2469L35.5742 52.8888C35.8134 52.7793 36.0725 52.7204 36.3353 52.7159C36.6007 52.7226 36.861 52.7901 37.0964 52.9134L40.0428 54.2222C40.6243 54.4906 41.2566 54.6295 41.8965 54.6295C42.5364 54.6295 43.1686 54.4906 43.7501 54.2222C44.3442 53.9817 44.8811 53.6175 45.3254 53.1536C45.7697 52.6897 46.1114 52.1366 46.3282 51.5306L47.4822 48.4934C47.5797 48.2482 47.7257 48.0254 47.9114 47.8387C48.0971 47.6519 48.3187 47.505 48.5625 47.4069L51.5824 46.2464C52.1734 46.0421 52.7161 45.7172 53.1766 45.2924C53.637 44.8675 54.0054 44.3517 54.2586 43.7771C54.5255 43.1922 54.6637 42.5563 54.6637 41.9127C54.6637 41.2692 54.5255 40.6333 54.2586 40.0484L52.9082 37.0358ZM28.4489 31.2709C28.4489 30.9239 28.713 30.7019 28.9668 30.7019H43.6941C43.9479 30.7019 44.2119 30.9239 44.2119 31.2709V41.3959C44.2119 41.7428 43.9479 41.9649 43.6941 41.9649H28.9668C28.713 41.9649 28.4489 41.7428 28.4489 41.3959V31.2709ZM28.9668 28.4649C27.4131 28.4649 26.2119 29.7538 26.2119 31.2709V41.3959C26.2119 42.9129 27.4131 44.2019 28.9668 44.2019H43.6941C45.2477 44.2019 46.4489 42.9129 46.4489 41.3959V31.2709C46.4489 29.7538 45.2477 28.4649 43.6941 28.4649H28.9668ZM38.1612 36.2325C38.1612 37.4768 37.1525 38.4854 35.9083 38.4854C34.664 38.4854 33.6553 37.4768 33.6553 36.2325C33.6553 34.9882 34.664 33.9796 35.9083 33.9796C37.1525 33.9796 38.1612 34.9882 38.1612 36.2325Z"',
//         subTitle:'Offer a fixed discount to your customers.',
//         color:'#ea4335'
//     },
//     {
//         title:'Buy X Get Y free',
//         path:'M52.3646 36.283C52.2479 36.0413 52.1873 35.7762 52.1873 35.5076C52.1873 35.239 52.2479 34.9738 52.3646 34.7322L53.6827 31.7305C53.9536 31.1338 54.0938 30.4856 54.0938 29.8296C54.0938 29.1736 53.9536 28.5253 53.6827 27.9285C53.4263 27.3465 53.0531 26.8238 52.5867 26.3934C52.1202 25.963 51.5704 25.6341 50.9718 25.4272L47.9126 24.2765C47.6656 24.1771 47.4413 24.0283 47.2531 23.8391C47.065 23.6499 46.9171 23.4243 46.8182 23.1759L45.6493 20.0742C45.4181 19.4689 45.0669 18.9172 44.6169 18.4528C44.167 17.9885 43.6277 17.6211 43.032 17.373C42.4364 17.1249 41.7967 17.0014 41.152 17.0099C40.5074 17.0185 39.8712 17.159 39.2822 17.4228L36.2977 18.7985C35.803 18.9988 35.2504 18.9988 34.7557 18.7985L31.7711 17.4228C31.1809 17.1549 30.5424 17.0113 29.895 17.0006C29.2475 16.99 28.6047 17.1126 28.0061 17.3609C27.4075 17.6093 26.8657 17.978 26.4139 18.4446C25.9622 18.9112 25.61 19.4658 25.3791 20.0742L24.2351 23.1759C24.1363 23.4243 23.9883 23.6499 23.8002 23.8391C23.6121 24.0283 23.3877 24.1771 23.1407 24.2765L20.0567 25.4272C19.4517 25.6594 18.9003 26.0135 18.4364 26.4678C17.9724 26.9221 17.6058 27.4671 17.3589 28.0691C17.112 28.6712 16.9901 29.3175 17.0006 29.9687C17.0112 30.6198 17.1541 31.2621 17.4204 31.8557L18.7883 34.8572C18.9874 35.3548 18.9874 35.9105 18.7883 36.4081L17.4204 39.4097C17.1563 40.0039 17.0198 40.6474 17.0198 41.2983C17.0198 41.9491 17.1563 42.5926 17.4204 43.1868C17.6689 43.7697 18.0364 44.2936 18.4992 44.7245C18.9619 45.1554 19.5095 45.4837 20.1064 45.6882L23.1905 46.8639C23.4375 46.9633 23.6619 47.112 23.85 47.3011C24.0381 47.4903 24.186 47.7161 24.2848 47.9645L25.4289 51.0411C25.7699 51.9467 26.3751 52.7275 27.1652 53.281C27.9552 53.8345 28.8932 54.1349 29.856 54.1428C30.5339 54.146 31.2043 54.0009 31.8208 53.7176L34.8054 52.3419C35.0477 52.2309 35.3102 52.1713 35.5764 52.1668C35.8452 52.1736 36.1089 52.2419 36.3474 52.3668L39.332 53.6926C39.9211 53.9645 40.5616 54.1052 41.2098 54.1052C41.858 54.1052 42.4984 53.9645 43.0875 53.6926C43.6893 53.4489 44.2331 53.08 44.6832 52.6101C45.1333 52.1402 45.4795 51.58 45.6991 50.966L46.868 47.8894C46.9668 47.641 47.1147 47.4154 47.3029 47.2262C47.491 47.037 47.7154 46.8882 47.9624 46.7888L51.0215 45.6132C51.6202 45.4063 52.1699 45.0772 52.6364 44.6468C53.1028 44.2164 53.476 43.6939 53.7325 43.1118C54.0028 42.5194 54.1429 41.8752 54.1429 41.2233C54.1429 40.5714 54.0028 39.9272 53.7325 39.3348L52.3646 36.283ZM40.4354 29H42V41.4796H39.5413V31.9616L36.468 33.5448V31.291L40.4354 29ZM35.5681 34.7182V36.8789H32.3644V40.1571H30.2037V36.8789H27V34.7182H30.2037V31.44H32.3644V34.7182H35.5681Z',
//         subTitle:'Offer free products on purchase of certain number of items.',
//         color:'#e183e3'
//     },
//     {
//         title:'Free Delivery',
//         path:'M52.9112 36.0358C52.796 35.7972 52.7362 35.5355 52.7362 35.2703C52.7362 35.0051 52.796 34.7434 52.9112 34.5048L54.2124 31.5417C54.4799 30.9526 54.6183 30.3127 54.6183 29.6651C54.6183 29.0175 54.4799 28.3775 54.2124 27.7884C53.9593 27.2138 53.5909 26.6979 53.1304 26.273C52.6699 25.8481 52.1272 25.5234 51.5362 25.3191L48.5163 24.1832C48.2724 24.0851 48.051 23.9382 47.8653 23.7514C47.6796 23.5646 47.5335 23.3419 47.4359 23.0967L46.282 20.0348C46.0538 19.4373 45.7071 18.8927 45.2629 18.4342C44.8187 17.9758 44.2863 17.6131 43.6983 17.3682C43.1103 17.1233 42.4788 17.0014 41.8424 17.0098C41.206 17.0183 40.578 17.157 39.9965 17.4174L37.0503 18.7754C36.5619 18.9732 36.0164 18.9732 35.5281 18.7754L32.5817 17.4174C31.9991 17.1529 31.3688 17.0111 30.7297 17.0006C30.0905 16.9901 29.4559 17.1112 28.865 17.3563C28.274 17.6014 27.7392 17.9655 27.2932 18.4261C26.8473 18.8867 26.4996 19.4342 26.2717 20.0348L25.1423 23.0967C25.0448 23.3419 24.8987 23.5646 24.713 23.7514C24.5273 23.9382 24.3058 24.0851 24.062 24.1832L21.0175 25.3191C20.4203 25.5484 19.876 25.8979 19.418 26.3464C18.96 26.7949 18.598 27.3329 18.3543 27.9272C18.1105 28.5216 17.9902 29.1596 18.0006 29.8024C18.0111 30.4452 18.1521 31.0792 18.415 31.6652L19.7653 34.6283C19.962 35.1194 19.962 35.6681 19.7653 36.1592L18.415 39.1224C18.1543 39.709 18.0195 40.3443 18.0195 40.9867C18.0195 41.6292 18.1543 42.2645 18.415 42.8511C18.6603 43.4265 19.0231 43.9437 19.4799 44.3691C19.9367 44.7945 20.4773 45.1185 21.0666 45.3204L24.1111 46.481C24.3549 46.5791 24.5764 46.7259 24.7621 46.9127C24.9478 47.0994 25.0939 47.3223 25.1914 47.5675L26.3209 50.6047C26.6575 51.4987 27.2549 52.2694 28.0349 52.8158C28.8148 53.3623 29.7407 53.6589 30.6912 53.6666C31.3604 53.6697 32.0222 53.5266 32.6308 53.2469L35.5771 51.8888C35.8164 51.7793 36.0754 51.7204 36.3382 51.7159C36.6036 51.7226 36.8639 51.7901 37.0994 51.9134L40.0457 53.2222C40.6272 53.4906 41.2596 53.6295 41.8994 53.6295C42.5393 53.6295 43.1715 53.4906 43.7531 53.2222C44.3472 52.9817 44.884 52.6175 45.3283 52.1536C45.7726 51.6897 46.1144 51.1366 46.3311 50.5306L47.4851 47.4934C47.5826 47.2482 47.7287 47.0254 47.9144 46.8387C48.1001 46.6519 48.3216 46.505 48.5654 46.4069L51.5853 45.2464C52.1763 45.0421 52.719 44.7172 53.1795 44.2924C53.64 43.8675 54.0083 43.3517 54.2615 42.7771C54.5284 42.1922 54.6667 41.5563 54.6667 40.9128C54.6667 40.2692 54.5284 39.6333 54.2615 39.0484L52.9112 36.0358ZM27.7132 28C27.3193 28 27 28.3193 27 28.7132V39.7257C27 40.1196 27.0777 40.2603 27.4715 40.2603H29.1691C28.8031 40.7203 28.5844 41.3027 28.5844 41.9362C28.5844 43.4239 29.7905 44.63 31.2783 44.63C32.7661 44.63 33.9721 43.4239 33.9721 41.9362C33.9721 41.3027 33.7535 40.7203 33.3875 40.2603H39.4683C39.1024 40.7203 38.8837 41.3027 38.8837 41.9362C38.8837 43.4239 40.0898 44.63 41.5776 44.63C43.0653 44.63 44.2714 43.4239 44.2714 41.9362C44.2714 41.3027 44.0527 40.7203 43.6868 40.2603H45.2961C45.8691 40.2603 46.3335 39.7958 46.3335 39.2229V35.1123C46.3335 34.8372 46.2242 34.5733 46.0297 34.3787L43.2556 31.6047C43.0611 31.4101 42.7972 31.3008 42.5221 31.3008H40.3102V28.7132C40.3102 28.3193 39.9908 28 39.5969 28H27.7132ZM38.3172 29.8862V38.3741H28.8862V29.8862H38.3172ZM44.4473 38.3741H40.3102V33.187H42.1705L44.4473 35.4639V38.3741ZM30.0109 41.9362C30.0109 41.2362 30.5783 40.6688 31.2783 40.6688C31.9783 40.6688 32.5457 41.2362 32.5457 41.9362C32.5457 42.6361 31.9783 43.2036 31.2783 43.2036C30.5783 43.2036 30.0109 42.6361 30.0109 41.9362ZM41.5776 40.6688C40.8776 40.6688 40.3102 41.2362 40.3102 41.9362C40.3102 42.6361 40.8776 43.2036 41.5776 43.2036C42.2775 43.2036 42.845 42.6361 42.845 41.9362C42.845 41.2362 42.2775 40.6688 41.5776 40.6688Z',
//         subTitle:'Offer free delivery to your customers.',
//         color:'#2d93fb'
//     },]

// export default function Coupons(props) {

//   React.useEffect(()=>{
//     props.getAllCoupons();
//     props.BxgycheckBox([])
//   },[])

//     const [open, setOpen] = React.useState(false);
//     const [selectedValue, setSelectedValue] = React.useState(coupons[1].title);

//     const handleClickOpen = () => {
//         setOpen(true);
//     };

//     const handleClose = (value) => {
//         setOpen(false);
//         setSelectedValue(value);
//         props.history.push(`/home/Coupons/${value.replace(/ /g, "")}`);
//     };

//     const handleListItemClick = (value) => {
//         handleClose(value);
//     };

//     return (
//         <>
//         {
//             props.AllCouponsLoading===true?
//             <Container maxWidth="md" style={{
//                 borderRadius: "10px",
//                marginTop:'100px',

//                 //   padding: "30px",

//                 //   flex: ' 1 1 0',
//                 width: "100%",
//             }}>
//                 <div style={{
// 											textAlign:'center',
// 										justifyContent:'center',
// 										alignItems:'center'}}>
// 										<img src={loader} alt="Loading"/>
// 										</div>
//                                         </Container>
//                                         :

//             props.AllCouponssuccess===true&&
//             props.AllCoupons.length!==0?

// <Container maxWidth="md" style={{
//                 // backgroundColor: "white",
//                 // border: "1px solid rgba(0, 0, 0, 0.16)",
//                 borderRadius: "10px",
//                marginTop:'100px',
//                 //   padding: "30px",

//                 //   flex: ' 1 1 0',
//                 width: "100%",
//             }}>
//                 <button className="couponButton" type="button" onClick={handleClickOpen}>
//                                 Create a coupon
//                             </button>
//                             <Dialog
//                                 onClose={handleClose} open={open} fullWidth={true}
//                                 maxWidth={'sm'}>
//                                 <DialogTitle>Select a coupon type</DialogTitle>
//                                 <List sx={{ pt: 0 }}>
//                                     {coupons.map((coupon) => (
//                                         <ListItem button onClick={() => handleListItemClick(coupon.title)} key={coupon.title}>
//                                             <ListItemAvatar>
//                                                 <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                     <path
//                                                         d="M67.5 0.5H4.5C2.29086 0.5 0.5 2.29086 0.5 4.5V67.5C0.5 69.7091 2.29086 71.5 4.5 71.5H67.5C69.7091 71.5 71.5 69.7091 71.5 67.5V4.5C71.5 2.29086 69.7091 0.5 67.5 0.5Z"
//                                                         fill={coupon.color} fill-opacity="0.1">
//                                                     </path>
//                                                     <path
//                                                     fill-rule="evenodd"
//                                                     clip-rule="evenodd"
//                                                         d={coupon.path}
//                                                         fill={coupon.color}>
//                                                     </path>
//                                                 </svg>
//                                             </ListItemAvatar>
//                                             <div  className='ListItem'>
//                                             <p className='section-text-5'>
//                                                 {coupon.title}
//                                             </p>
//                                             <p className='section-text-sub'>
//                                                 {coupon.subTitle}
//                                             </p>
//                                             </div>
//                                         </ListItem>
//                                     ))}

//                                 </List>
//                             </Dialog>

//                  <Row  style={{paddingTop:'10px'}}>

//  {props.AllCoupons&&
//     props.AllCoupons.data&&
//     props.AllCoupons.data.listAllCoupons.map((C)=>(
//        <Col md={6} xs ={12} sm={12} style={{paddingRight:'30px',paddingBottom:'20px'}}>

//         <CouponCard
//         couponCode={C.couponCode}
//         totalCustUseCount={C.totalCustUseCount}
//         custUseCount={C.custUseCount}
//         type={C.type}
//         disAmt={C.disAmt}
//         discountPercent={C.discountPercent}
//         minPurAmt={C.minPurAmt}
//         status={C.status}
//         id={C.id}
//         appliedCount={C.appliedCount}
//         buyItemNo={C.buyItemNo}
//         getItemNo={C.getItemNo}
//         endDate={C.endDate}
//         {...props}
//         />
//         </Col>
//     ))
// }
// </Row>
//             </Container>

//             :

//             <Container maxWidth="md" style={{
//                 backgroundColor: "white",
//                 border: "1px solid rgba(0, 0, 0, 0.16)",
//                 borderRadius: "10px",
//                 //   Top: "90px",
//                 //   padding: "30px",
//                 display: 'flex',
//                 //   flex: ' 1 1 0',
//                 width: "100%",
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 textAlign: 'center',
//                 margin: '0 auto',
//                 marginTop:'50px'
//             }}>
//                 <Box sx={{ color: '#FFFFFF', height: '100vh' }} >
//                     <div className="no-coupons-container wv-center">
//                         <p className="title m8">Get more sales with coupons</p>
//                         <p className="description mb0">
//                             Now you can create and share coupons for your store to get more and more orders on your store.
//                         </p>
//                         <div>
//                             <button className="couponButton" type="button" onClick={handleClickOpen}>
//                                 Create a coupon
//                             </button>
//                             <Dialog
//                                 onClose={handleClose} open={open} fullWidth={true}
//                                 maxWidth={'sm'}>
//                                 <DialogTitle>Select a coupon type</DialogTitle>
//                                 <List sx={{ pt: 0 }}>
//                                     {coupons.map((coupon) => (
//                                         <ListItem button onClick={() => handleListItemClick(coupon.title)} key={coupon.title}>
//                                             <ListItemAvatar>
//                                                 <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                     <path
//                                                         d="M67.5 0.5H4.5C2.29086 0.5 0.5 2.29086 0.5 4.5V67.5C0.5 69.7091 2.29086 71.5 4.5 71.5H67.5C69.7091 71.5 71.5 69.7091 71.5 67.5V4.5C71.5 2.29086 69.7091 0.5 67.5 0.5Z"
//                                                         fill={coupon.color} fill-opacity="0.1">
//                                                     </path>
//                                                     <path
//                                                     fill-rule="evenodd"
//                                                     clip-rule="evenodd"
//                                                         d={coupon.path}
//                                                         fill={coupon.color}>
//                                                     </path>
//                                                 </svg>
//                                             </ListItemAvatar>
//                                             <div className='ListItem'>
//                                             <p className='section-text-5'>
//                                                 {coupon.title}
//                                             </p>
//                                             <p className='section-text-sub'>
//                                                 {coupon.subTitle}
//                                             </p>
//                                             </div>
//                                         </ListItem>
//                                     ))}

//                                 </List>
//                             </Dialog>
//                         </div>
//                     </div>
//                 </Box>
//             </Container>

//         }

//         </>
//     )
// }

// import logo from "./logo.svg";
// import "./App.css";
// import { useState } from "react";
// import CoupounType from "./CoupounType";
// import PercentageDiscountCoupoun from "./PercentageDiscountCoupoun";

// function App() {
//   const [coupounPage, setCoupounPage] = useState(true);
//   const [coupounTypePage, setCoupounTypePage] = useState(false);
//   const [percentageDiscountCoupoun, setPercentageDiscountCoupoun] =
//     useState(false);
//   const [createNewCoupoun, setCreateNewCoupoun] = useState([]);
//   const [onGoingCoupoun, setOnGoingCoupoun] = useState([]);
//   const [upComingCoupoun, setUpComingCoupoun] = useState([]);

//   function createCoupounPage() {
//     setCoupounTypePage(true);
//     setCoupounPage(false);
//     setPercentageDiscountCoupoun(false);
//   }

//   function createPercentageDiscount() {
//     setCoupounTypePage(false);
//     setCoupounPage(false);
//     setPercentageDiscountCoupoun(true);
//   }

//   function createCoupoun(coupounObject) {
//     setCoupounTypePage(false);
//     setCoupounPage(true);
//     setPercentageDiscountCoupoun(false);
//     const currentDate = new Date();
//     currentDate.setHours(0, 0, 0, 0);

//     const fromDate = new Date(coupounObject.fromDate);
//     const toDate = new Date(coupounObject.toDate);
//     fromDate.setHours(0, 0, 0, 0);
//     toDate.setHours(0, 0, 0, 0);

//     const differenceInMs = Math.abs(fromDate - toDate);
//     const millisecondsPerDay = 1000 * 60 * 60 * 24;
//     const remainingDays = Math.floor(differenceInMs / millisecondsPerDay);

//     if (fromDate > currentDate) {
//       setUpComingCoupoun((val) => [
//         ...val,
//         { ...coupounObject, remainingDays: remainingDays },
//       ]);
//     }

//     if (fromDate.getTime() === currentDate.getTime()) {
//       setOnGoingCoupoun((val) => [
//         ...val,
//         { ...coupounObject, remainingDays: remainingDays },
//       ]);
//     }
//   }
//   return (
//     <div>
//       {coupounPage && (
//         <div className="Coupoun-details">
//           <div className="coupoun-header">
//             <div className="btn-ongoing">Ongoing</div>
//             <div className="btn-upcoming">upcoming</div>
//           </div>
//           <div className="page-container">
//             {/* Content for left section */}
//             <div className="left-section">
//               {onGoingCoupoun.map((val) => (
//                 <>
//                   <div className="left-sec">
//                     <p>{val.coupouncode}</p>
//                     <p>{val.userPerCustomer}</p>
//                     <p>{val.discountPercent}</p>
//                     <p>{val.minimumOrderValue}</p>
//                     <p>{val.maximumDiscount}</p>
//                   </div>
//                   <p>Remaining Days:{val.remainingDays}</p>
//                 </>
//               ))}
//               {onGoingCoupoun.length < 1 && (
//                 <div className="left-sub-section">
//                   <h2>No on going coupoun</h2>
//                   <p>There is no coupoun.</p>
//                 </div>
//               )}
//             </div>

//             {/* Content for right section */}
//             <div className="right-section">
//               {upComingCoupoun.map((val) => (
//                 <>
//                   <div className="right-sec">
//                     <p>{val.coupouncode}</p>
//                     <p>{val.userPerCustomer}</p>
//                     <p>{val.discountPercent}</p>
//                     <p>{val.minimumOrderValue}</p>
//                     <p>{val.maximumDiscount}</p>
//                   </div>
//                   <p>Remaining Days:{val.remainingDays}</p>
//                 </>
//               ))}

//               {upComingCoupoun.length < 1 && (
//                 <div className="right-sub-section">
//                   <h2>No upcomingcoupoun</h2>
//                   <p>There is no upComingCoupoun.</p>
//                 </div>
//               )}
//             </div>
//           </div>
//           <div className="create-coupoun-btn">
//             <button className="btn" onClick={createCoupounPage}>
//               create coupoun
//             </button>
//           </div>
//         </div>
//       )}
//       {coupounTypePage && (
//         <CoupounType createPercentageDiscount={createPercentageDiscount} />
//       )}
//       {percentageDiscountCoupoun && (
//         <PercentageDiscountCoupoun createCoupoun={createCoupoun} />
//       )}
//     </div>
//   );
// }

// export default App;

//new code

// import { React, useState } from "react";
// import CustomButton from "../Commoncomponents/button/index";
// import Coupontype from "./Coupontype";
// import Couponicon from "../../utils/Icon/Coupon.svg";
// import CustomToggleButton from "../Commoncomponents/toggleButton";
// import Delete from "../../utils/Icon/delete.svg";
// import CustomCard from "../Commoncomponents/card";
// import CouponCard from "./CouponCard";
// import {
//   Box,
//   Grid,
//   Typography,
//   InputAdornment,
//   useMediaQuery,
//   useTheme,
// } from "../MUIComponents/index";
// import {
//   ButtonFontSize_18,
//   ButtonFontSize_18_xs_10,
//   HeaderNavigationFontSize_20,
//   contentFontSize_16,
//   contentFontSize_20,
// } from "../Typography";
// import Couponsubtype from "./Couponsubtype";

// const Coupon = (props) => {
//   //   const [activeButton, setActiveButton] = useState("onGoing");
//   //   const [coupounPage, setCoupounPage] = useState(true);
//   //   const [coupounTypePage, setCoupounTypePage] = useState(false);
//   //   const [percentageDiscountCoupoun, setPercentageDiscountCoupoun] =
//   //     useState(false);
//   //   const [onGoingCoupoun, setOnGoingCoupoun] = useState([]);
//   //   const [upComingCoupoun, setUpComingCoupoun] = useState([]);

//   console.log("OnGoingCoupoun in the array ", onGoingCoupoun);
//   function handleClickOne() {
//     setActiveButton("onGoing");
//   }
//   function handleClickTwo() {
//     setActiveButton("upComing");
//   }
//   function handleCoupon() {}

//   const theme = useTheme();
//   const upXlmatch = useMediaQuery(theme.breakpoints.up("xl"));
//   const xlmatch = useMediaQuery(theme.breakpoints.down("xl"));
//   const lgmatch = useMediaQuery(theme.breakpoints.down("lg"));
//   const mdmatch = useMediaQuery(theme.breakpoints.down("md"));
//   const smmatch = useMediaQuery(theme.breakpoints.down("sm"));
//   const xsmatch = useMediaQuery(theme.breakpoints.down("xs"));

//   const matches = useMediaQuery(theme.breakpoints.down("md"));

//   function createCoupounPage() {
//     setCoupounTypePage(true);
//     setCoupounPage(false);
//     setPercentageDiscountCoupoun(false);
//   }

//   function createPercentageDiscount() {
//     setCoupounTypePage(false);
//     setCoupounPage(false);
//     setPercentageDiscountCoupoun(true);
//   }

//   //   function createCoupoun(coupounObject) {
//   //     setCoupounTypePage(false);
//   //     setCoupounPage(true);
//   //     setPercentageDiscountCoupoun(false);
//   //     console.log(coupounObject)
//   //     const currentDate = new Date();
//   //     currentDate.setHours(0, 0, 0, 0);

//   //     const fromDate = new Date(coupounObject.fromDate);
//   //     const toDate = new Date(coupounObject.toDate);
//   //     fromDate.setHours(0, 0, 0, 0);
//   //     toDate.setHours(0, 0, 0, 0);

//   //     const differenceInMs = Math.abs(fromDate - toDate);
//   //     const millisecondsPerDay = 1000 * 60 * 60 * 24;
//   //     const remainingDays = Math.floor(differenceInMs / millisecondsPerDay);

//   //     if (fromDate > currentDate) {
//   //       setUpComingCoupoun((val) => [
//   //         ...val,
//   //         { ...coupounObject, remainingDays: remainingDays },
//   //       ]);
//   //     }

//   //     if (fromDate.getTime() === currentDate.getTime()) {
//   //       setOnGoingCoupoun((val) => [
//   //         ...val,
//   //         { ...coupounObject, remainingDays: remainingDays },
//   //       ]);
//   //     }
//   //   }

//   return (
//     <>
//       {coupounTypePage ? (
//         <Coupontype
//           createPercentageDiscount={createPercentageDiscount}
//           setCoupounPage={setCoupounPage}
//         />
//       ) : percentageDiscountCoupoun ? (
//         <Couponsubtype createCoupoun={createCoupoun} />
//       ) : (
//         <>
//           {/* {coupounPage && ( */}
//           {
//             <div>
//               <div className="custm-button">
//                 <CustomButton
//                   width="50%"
//                   height="50px"
//                   borderRadius="15px"
//                   onClick={handleClickOne}
//                   color={activeButton === "onGoing" ? "white" : "grey"}
//                   variant={
//                     activeButton === "onGoing" ? "contained" : "outlined"
//                   }
//                   background={
//                     activeButton === "onGoing" ? "rgb(101, 155, 27)" : "white"
//                   }
//                 >
//                   Ongoing
//                 </CustomButton>
//                 <CustomButton
//                   width="50%"
//                   height="50px"
//                   borderRadius="15px"
//                   onClick={handleClickTwo}
//                   color={activeButton === "upComing" ? "white" : "grey"}
//                   variant={
//                     activeButton === "upComing" ? "contained" : "outlined"
//                   }
//                   background={
//                     activeButton === "upComing" ? "rgb(101, 155, 27)" : "white"
//                   }
//                 >
//                   Upcoming
//                 </CustomButton>
//               </div>
//               <div className="coupon-card-main">
//                 {activeButton == "onGoing" && (
//                   <>
//                     {/* {start} */}

//                     {props.AllCoupons &&
//                       props.AllCoupons.data &&
//                       props.AllCoupons.data.listAllCoupons.map((C) => (
//                         //   <Col md={6} xs ={12} sm={12} style={{paddingRight:'30px',paddingBottom:'20px'}}>

//                         <CouponCard
//                           couponCode={C.couponCode}
//                           totalCustUseCount={C.totalCustUseCount}
//                           custUseCount={C.custUseCount}
//                           type={C.type}
//                           disAmt={C.disAmt}
//                           discountPercent={C.discountPercent}
//                           minPurAmt={C.minPurAmt}
//                           status={C.status}
//                           id={C.id}
//                           appliedCount={C.appliedCount}
//                           buyItemNo={C.buyItemNo}
//                           getItemNo={C.getItemNo}
//                           endDate={C.endDate}
//                           {...props}
//                         />
//                       ))}

//                     {/* {end} */}
//                   </>
//                 )}
//               </div>

//               {activeButton == "upComing" && (
//                 <>
//                   {props.AllCoupons &&
//                     props.AllCoupons.data &&
//                     props.AllCoupons.data.listAllCoupons.map((C) => (
//                       //   <Col md={6} xs ={12} sm={12} style={{paddingRight:'30px',paddingBottom:'20px'}}>

//                       <CouponCard
//                         couponCode={C.couponCode}
//                         totalCustUseCount={C.totalCustUseCount}
//                         custUseCount={C.custUseCount}
//                         type={C.type}
//                         disAmt={C.disAmt}
//                         discountPercent={C.discountPercent}
//                         minPurAmt={C.minPurAmt}
//                         status={C.status}
//                         id={C.id}
//                         appliedCount={C.appliedCount}
//                         buyItemNo={C.buyItemNo}
//                         getItemNo={C.getItemNo}
//                         endDate={C.endDate}
//                         {...props}
//                       />
//                     ))}

//                   {/*<CustomCard
//                           width={"50%"}
//                           padding={"0px"}
//                           background="black"
//                           borderRadius={"30px"}
//                           sx={{
//                             zIndex: "1",
//                             position: " relative",
//                             display: "flex",
//                             justifyContent: "space-between",
//                             flexDirection: "column",
//                             borderRadius: "30px",
//                             boxShadow: "0 2px 6px #1a181e0a",
//                             overflow: "hidden",
//                           }}
//                           className="coupon-card"
//                         >
//                           <div
//                             style={{
//                               display: "flex",
//                               padding: "25px",
//                               paddingBottom: "0px",
//                               flex: 1,
//                             }}
//                           >
//                             <div className="coupon-item-container">
//                               <div className="coupon-heading">
//                                 <span className="coupon-name">

//                                   <span className="name">

//                                     {val.coupouncode}
//                                   </span>
//                                 </span>

//                               </div>
//                               <div className="coupon-description">

//                                 {val.discountPercent}% off on all order above ₹{" "}
//                                 {val.minimumOrderValue} up to ₹
//                                 {val.maximumDiscount}
//                                 <span>
//                                   <img src={Couponicon} alt="coupon" />
//                                 </span>
//                               </div>
//                               <div className="status">
//                                 <span className="times-used-div">
//                                   <span className="times-used-div-heading">
//                                     {"TIMES USED"}
//                                   </span>
//                                   <span className="times-used-div-desc">

//                                     00
//                                   </span>
//                                 </span>
//                                 <div
//                                   style={{
//                                     borderLeft: "2px solid green",
//                                     width: "10%",
//                                     marginLeft: "40px",
//                                   }}
//                                 ></div>
//                                 <span className="times-used-div">
//                                   <span className="times-used-div-heading">
//                                     {"USES PER CUSTOMER"}
//                                   </span>
//                                   <span className="times-used-div-desc">

//                                     {val.userPerCustomer}
//                                   </span>
//                                 </span>
//                               </div>
//                             </div>
//                             <div className="card-off">
//                               <div class="Off">{val.discountPercent}%OFF</div>
//                             </div>
//                           </div>
//                           <div className="card-bottom">
//                             <div className="toggle">
//                               <CustomToggleButton
//                                 initialOnline={true}
//                                 // onClick={handleToggle}
//                                 textOne="Active"
//                                 textTwo="Inactive"
//                                 textFont="19px"
//                                 {...customStyles}
//                               ></CustomToggleButton>
//                             </div>
//                             <div className="remaining">
//                               <p>Remaining Days:{val.remainingDays}</p>
//                             </div>
//                             <div style={{ padding: "5px" }}>
//                               <img src={Delete} alt="Delete" />
//                             </div>
//                           </div>
//                           <div className="circle circle1" />
//                           <div className="circle circle2" />

//                         </CustomCard>
//                       </div>
//                     ))} */}
//                 </>
//               )}
//               <div style={{ marginTop: "40px", textAlign: "center" }}>
//                 <CustomButton
//                   width={
//                     upXlmatch
//                       ? "358px"
//                       : xlmatch
//                       ? lgmatch
//                         ? mdmatch
//                           ? smmatch
//                             ? xsmatch
//                               ? "250px"
//                               : "250px"
//                             : "310px"
//                           : "330px"
//                         : "340px"
//                       : "358px"
//                   }
//                   borderRadius="20px"
//                   onClick={createCoupounPage}
//                 >
//                   <Typography
//                     fontSize={ButtonFontSize_18_xs_10}
//                     className="create-coupon"
//                   >
//                     {" "}
//                     Create Coupon
//                   </Typography>
//                 </CustomButton>
//               </div>
//             </div>
//           }
//         </>
//       )}
//     </>
//   );
// };

// export default Coupon;

//original code by berlin
// new new code

// import React, { useEffect, useState } from "react";
// import CouponCard from "./CouponCard";
// import CustomButton from "../Commoncomponents/button/index";
// import {
//   Box,
//   Grid,
//   Typography,
//   useMediaQuery,
//   useTheme,
// } from "../MUIComponents/index";
// import { ButtonFontSize_18_xs_10 } from "../Typography/index";
// import Coupontype from "./Coupontype";

// function Coupons(props) {
//   const [buttonSlotsColor, setButtonSlotsColor] = useState(true);
//   const [buttonSettingsColor, setButtonSettingsColor] = useState(false);
//   const [coupounPage, setCoupounPage] = useState(true);
//   const [coupounTypePage, setCoupounTypePage] = useState(false);
//   const [percentageDiscountCoupoun, setPercentageDiscountCoupoun] =
//     useState(false);

//     useEffect(()=>{
//         props.getAllCoupons();
//     },[])

//     var current = new Date();
//     var CurrentDate = current.getTime();

//     if (props.AllCoupons && props.AllCoupons.data && props.AllCoupons.data.listAllCoupons) {
//       var startDates = props.AllCoupons.data.listAllCoupons.map(coupon => coupon.startDate);
//       console.log("this is the start date ",startDates);
//   }
//   function createCoupounPage() {
//     setCoupounTypePage(true);
//     setButtonSlotsColor(false);
//     setButtonSettingsColor(false);
//   }

//   function handleSlotsColor() {
//     setButtonSlotsColor(true);
//     setButtonSettingsColor(false);
//   }

//   function handleSettingsColor() {
//     setButtonSettingsColor(true);
//     setButtonSlotsColor(false);
//   }

//   console.log("this is new berlin coupon", props);
//   React.useEffect(() => {
//     props.getAllCoupons();
//     props.BxgycheckBox([]);
//   }, []);

//   const theme = useTheme();
//   const upXlmatch = useMediaQuery(theme.breakpoints.up("xl"));
//   const xlmatch = useMediaQuery(theme.breakpoints.down("xl"));
//   const lgmatch = useMediaQuery(theme.breakpoints.down("lg"));
//   const mdmatch = useMediaQuery(theme.breakpoints.down("md"));
//   const smmatch = useMediaQuery(theme.breakpoints.down("sm"));
//   const xsmatch = useMediaQuery(theme.breakpoints.down("xs"));

//   return (
//     <>
//       {!coupounTypePage && (
//         <Box sx={{ flexGrow: 1 }}>
//           <Grid container spacing={2}>
//             <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
//               <div>
//                 <CustomButton
//                   width="100%"
//                   height="100%"
//                   borderRadius="15px"
//                   onClick={handleSlotsColor}
//                   variant={buttonSlotsColor ? "contained" : "outlined"}
//                   borderColor="#659B1B"
//                   background={buttonSlotsColor ? "#659B1B" : "white"}
//                   color={buttonSlotsColor ? "white" : "#646464"}
//                   size="large"
//                 >
//                   <Typography
//                     fontSize={ButtonFontSize_18_xs_10}
//                     className="ManageInitialBtnStyle"
//                   >
//                     Ongoing
//                   </Typography>
//                 </CustomButton>
//               </div>
//             </Grid>
//             <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
//               <div>
//                 <CustomButton
//                   width="100%"
//                   height="100%"
//                   borderRadius="15px"
//                   onClick={handleSettingsColor}
//                   borderColor="#659B1B"
//                   variant={buttonSettingsColor ? "contained" : "outlined"}
//                   background={buttonSettingsColor ? "#659B1B" : "white"}
//                   color={buttonSettingsColor ? "white" : "#646464"}
//                   size="large"
//                 >
//                   <Typography
//                     fontSize={ButtonFontSize_18_xs_10}
//                     className="ManageInitialBtnStyle"
//                   >
//                     Upcoming
//                   </Typography>
//                 </CustomButton>
//               </div>
//             </Grid>
//           </Grid>
//         </Box>
//       )}
//       {buttonSlotsColor &&
//         props.AllCoupons &&
//         props.AllCoupons.data &&
//         props.AllCoupons.data.listAllCoupons.map((C) => (
//           //   <Col md={6} xs ={12} sm={12} style={{paddingRight:'30px',paddingBottom:'20px'}}>

//           <CouponCard
//             couponCode={C.couponCode}
//             totalCustUseCount={C.totalCustUseCount}
//             custUseCount={C.custUseCount}
//             type={C.type}
//             disAmt={C.disAmt}
//             discountPercent={C.discountPercent}
//             minPurAmt={C.minPurAmt}
//             status={C.status}
//             id={C.id}
//             appliedCount={C.appliedCount}
//             buyItemNo={C.buyItemNo}
//             getItemNo={C.getItemNo}
//             endDate={C.endDate}
//             startDate={C.startDate}
//             {...props}
//           />
//         ))}

//       {buttonSettingsColor && <div>this is upcoming</div>}
//       {coupounTypePage && (
//         <Coupontype
//           setCoupounTypePage={setCoupounTypePage}
//           setButtonSlotsColor={setButtonSlotsColor}
//         />
//       )}

//       {!coupounTypePage && (
//         <div style={{ marginTop: "40px", textAlign: "center" }}>
//           <CustomButton
//             width={
//               upXlmatch
//                 ? "358px"
//                 : xlmatch
//                 ? lgmatch
//                   ? mdmatch
//                     ? smmatch
//                       ? xsmatch
//                         ? "250px"
//                         : "250px"
//                       : "310px"
//                     : "330px"
//                   : "340px"
//                 : "358px"
//             }
//             borderRadius="20px"
//             onClick={createCoupounPage}
//           >
//             <Typography
//               fontSize={ButtonFontSize_18_xs_10}
//               className="create-coupon"
//             >
//               {" "}
//               Create Coupon
//             </Typography>
//           </CustomButton>
//         </div>
//       )}
//     </>
//   );
// }

// export default Coupons;

//new modified  code by berlin

import React, { useEffect, useState } from "react";
import CouponCard from "./CouponCard";
import CustomButton from "../Commoncomponents/button/index";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "../MUIComponents/index";
import { ButtonFontSize_18_xs_10 } from "../Typography/index";
import Coupontype from "./Coupontype";
import { useNavigate } from "react-router-dom";
import UpcomingCoupons from "./UpcomingCoupons";
import {CircularProgress} from '../MUIComponents/index';
import { useSelector } from "react-redux";

function Coupons(props) {
  const [buttonSlotsColor, setButtonSlotsColor] = useState(true);
  const [buttonSettingsColor, setButtonSettingsColor] = useState(false);
  const [coupounPage, setCoupounPage] = useState(true);
  const [coupounTypePage, setCoupounTypePage] = useState(false);
  const [percentageDiscountCoupoun, setPercentageDiscountCoupoun] =
    useState(false);
  const [ongoingCoupons, setOngoingCoupons] = useState([]);
  // const [upcomingCoupons, setUpcomingCoupons] = useState([]);

  const nav = useNavigate();
  const { AllOngoingCouponsLoading } = useSelector((state) => state.SignInReducer);

  useEffect(() => {
    // props.getAllCoupons();
    // props.getAllUpComingCoupons();
    props.getAllOnGoingCoupons();
  }, []);


 
  useEffect(() => {
    if (
      props?.AllOngoingCoupons !== undefined
      
    ) {
      const ongoing =
        props?.AllOngoingCoupons?.data?.listAllOngoingCoupons || [];
      
      const ongoingCoupons = Array.isArray(ongoing) ? ongoing : [ongoing];
    

      setOngoingCoupons(ongoingCoupons);
    }
  }, [props.AllOngoingCoupons]);

 

  function createCoupounPage() {
    nav("/home/Coupontype");
  }

  function handleSlotsColor() {
    setButtonSlotsColor(true);
    setButtonSettingsColor(false);
  }

  function handleSettingsColor() {
    setButtonSettingsColor(true);
    setButtonSlotsColor(false);
    nav('/home/UpcomingCoupons')
  }

  const theme = useTheme();
  const upXlmatch = useMediaQuery(theme.breakpoints.up("xl"));
  const xlmatch = useMediaQuery(theme.breakpoints.down("xl"));
  const lgmatch = useMediaQuery(theme.breakpoints.down("lg"));
  const mdmatch = useMediaQuery(theme.breakpoints.down("md"));
  const smmatch = useMediaQuery(theme.breakpoints.down("sm"));
  const xsmatch = useMediaQuery(theme.breakpoints.down("xs"));

  function calculateRemainingDays(endDate) {
    const currentDate = new Date().getTime();
    const diffTime = endDate - currentDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  }

  return (
    <div style={{ background: "rgb(244, 245, 249)"}}>
     
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={5}>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div>
                <CustomButton
                  width="100%"
                  height="100%"
                  borderRadius="15px"
                  onClick={handleSlotsColor}
                  variant="contained"
                  borderColor="#659B1B"
                  background="#659B1B"
                  color="white" 
                  size="large"
                  matchPadding={true}
                  padding="10px"
                >
                  <Typography
                    fontSize={ButtonFontSize_18_xs_10}
                    className="ManageInitialBtnStyle"
                  >
                    Ongoing
                  </Typography>
                </CustomButton>
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div>
                <CustomButton
                  width="100%"
                  height="100%"
                  borderRadius="15px"
                  onClick={handleSettingsColor}
                  borderColor="#659B1B"
                  variant="outlined"
                  background="white"
                  color="#646464"
                  size="large"
                  matchPadding={true}
                  padding="10px"
                >
                  <Typography
                    fontSize={ButtonFontSize_18_xs_10}
                    className="ManageInitialBtnStyle"
                  >
                    Upcoming
                  </Typography>
                </CustomButton>
              </div>
            </Grid>
          </Grid>
        </Box>
     
      <div style={{ marginTop: "30px", height: "100%" }}>
      
{  ongoingCoupons.length!=0?        <Grid container spacing={5}>
            {ongoingCoupons.map((C) => (
              <Grid item key={C.id} xs={12} sm={6} md={6} lg={6} xl={6}>
                <CouponCard
                  key={C.id}
                  couponCode={C.couponCode}
                  totalCustUseCount={C.totalCustUseCount}
                  custUseCount={C.custUseCount}
                  type={C.type}
                  disAmt={C.disAmt}
                  discountPercent={C.discountPercent}
                  minPurAmt={C.minPurAmt}
                  status={C.status}
                  id={C.id}
                  appliedCount={C.appliedCount}
                  buyItemNo={C.buyItemNo}
                  getItemNo={C.getItemNo}
                  endDate={C.endDate}
                  startDate={C.startDate}
                  remainingDays={calculateRemainingDays(C.endDate)}
                  {...props}
                />
              </Grid>
            ))}
          </Grid>:
          ( AllOngoingCouponsLoading? (<div style={{height:"100%",width:"100%",display:"flex",alignItems:"center",justifyContent:"center"}}> <CircularProgress color="success" /></div>)
          :
           (<>No ongoing coupons</>))
          }
       
      </div>
      {/* <div style={{ marginTop: "30px" }}>
        {buttonSettingsColor && (
          <UpcomingCoupons {...props}/>
           
        )}
      </div> */}

      {/* {coupounTypePage && (
        <Coupontype
          setCoupounTypePage={setCoupounTypePage}
          setButtonSlotsColor={setButtonSlotsColor}
        />
      )} */}

      
        <div style={{ marginTop: "140px", textAlign: "center" }}>
          <CustomButton
            width={
              upXlmatch
                ? "358px"
                : xlmatch
                ? lgmatch
                  ? mdmatch
                    ? smmatch
                      ? xsmatch
                        ? "250px"
                        : "250px"
                      : "310px"
                    : "330px"
                  : "340px"
                : "358px"
            }
            borderRadius="20px"
            onClick={createCoupounPage}
            matchPadding={true}
            padding="10px"
          >
            <Typography
              fontSize={ButtonFontSize_18_xs_10}
              className="create-coupon"
            >
              Create Coupon
            </Typography>
          </CustomButton>
        </div>
     
    </div>
  );
}

export default Coupons;
